angular.module('tc.iconProfile')

/**
* @ngdoc service
* @name tcApp.service:iconProfileService
* @description
* Handles general, non-presentation related icon profile behaviour
*/

.factory('IconProfileService', function(SystemRouter, $log) {
	// Request variables that can be passed when getting the icon profile data
	// Should match the macro in system.Icons
	var iconExpressionVars = ['EpisodeID','ApptID','SchedDate','PatientID','WardID','RoyalID','OperRoomID',
	'SchedID','OEOrdID','AnaestID','AnaeOperID','SundryID','STGRowId','RFPWRowId','WLID','OEOrdIDs',
	'MSGLBTestSetItemID','MSGLBTestSetID','LBEpisodeID','LBProtocolProcedureID','LBTestSetItemID','LBBloodProductID',
	'AUDRowId','PatientBabyID','OEOrdExecID','InfoLink','InfoLinkContext','InfoLinkParam','InfoLinkHL7Main',
	'InfoLinkRow','LBSpecimenContainerID','LBProtocolMaterialID','LBTransferID','LBTestSetID'];
	
	// Returns a promise that will set the icons on the iconProfileObject when resolved
	var getIconProfileData = function(iconProfileId, iconProfileValue, iconProfileObject,
										componentName, arrayNode, contextString) {
		if ((angular.isUndefined(iconProfileValue)) || (iconProfileValue === '')) {
			iconProfileObject.icons = [];
			return;
		}
		iconProfileValue = iconProfileValue.toString().split('^');
		var episodeId = iconProfileValue[0];
		var patientId = iconProfileValue[3];
		var schedId = iconProfileValue[7];
		if ((angular.isUndefined(iconProfileId))
			|| (iconProfileId === '') || ((patientId === '') && (episodeId === '') && (schedId === ''))) {
			iconProfileObject.icons = [];
			return;
		}
		
		var iconProfileParams = {};
		angular.forEach(iconExpressionVars, function(iconExpressionVar, iconExpressionVarIndex) {
			iconProfileParams[iconExpressionVar] = iconProfileValue[iconExpressionVarIndex];
		});
		if (angular.isDefined(contextString) && (contextString !== '')) {
			iconProfileParams['CONTEXT'] = contextString;
		}
		var promise = SystemRouter.fetchIconProfileData(iconProfileId, componentName, arrayNode, iconProfileParams);
		promise = promise.then(
			function(response) {
				if (response.data) {
					if (angular.isDefined(iconProfileObject)) {
						iconProfileObject.icons = [];
					}
					if (response.data.error) {
						$log.error('Error: ', response.data.error);
					} else {
						if ((angular.isDefined(iconProfileObject)) && (angular.isDefined(response.data.icons))) {
							iconProfileObject.icons = response.data.icons;
						}
					}
				}
			});
		return promise;
	};
	
	// Returns the icon profile value string required to pass to the getIconProfileData function
	// (where the value string is not built on the server side)
	// See system.Icons:GetIconProfileData and epr.CTIconProfile:Gather
	var buildIconProfileValue = function(iconProfileParams) {
		var iconProfileValues = [];
		iconExpressionVars.forEach(function(paramName, paramIndex) { //eslint-disable-line
			iconProfileValues[paramIndex] = iconProfileParams[paramName];
		});
			
		return iconProfileValues.join('^');
	};
	
	return {
		getIconProfileData: getIconProfileData,
		buildIconProfileValue: buildIconProfileValue,
	};
});
